import { render, staticRenderFns } from "./IncomingTransactions.vue?vue&type=template&id=2268780c&"
import script from "./IncomingTransactions.vue?vue&type=script&lang=js&"
export * from "./IncomingTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports